// Handler when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  init();
});

function init() {
  require("./events/event-tabs");
}
